import React from 'react';

import AppContextPropsType from '../../types/AppContextPropsType';
import defaultConfig from './HealthMeProvider/defaultConfig';

export default React.createContext<AppContextPropsType>(defaultConfig);
